<template>
  <main class="page">
    <div class="page__back" @click="$router.push({name: 'ApproveList'})">
      <div class="page__back-icon">
        <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 5.5H2M2 5.5L6.14815 1M2 5.5L6.14815 10" stroke="#95A4C0" stroke-width="1.5"/>
        </svg>
      </div>
      Назад
    </div>
    <section class="section page__header">
      <div class="page__row">
        <div class="page__item">
          <h1 class="title">{{ isCreate ? 'Создать лист согласования' : 'Редактировать лист согласования' }}</h1>
        </div>
      </div>

      <transition name="fade">
        <div class="page__row" v-show="!this.isCreate && isDisabling">
          <div class="page__item" v-if="canEdit" style="margin-right: 10px;">
            <AppButtonSmEdit title="Изменить"
                             @click.native="doEditApprove"
            />
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div class="page__row" v-show="!this.isCreate && isDisabling">
          <div class="page__item" style="margin-right: 10px;">
            <AppButtonSmExport title="Лист для поставки, услуги"
                       type="third"
                       @click.native="getReport('Поставка, услуги')"
                       width="auto"
            />
          </div>
          <div class="page__item" style="margin-right: 10px;">
            <AppButtonSmExport title="Лист для подряда"
                       type="third"
                       @click.native="getReport('Подряд')"
                       width="auto"
            />
          </div>
          <div class="page__item">
            <AppButtonSmExport title="Лист для доп. соглашения, приложения"
                       type="third"
                       @click.native="getReport('Доп. соглашения, приложения')"
                       width="auto"
            />
          </div>
        </div>
      </transition>

      <transition name="fade" v-if="vote.canVote && approve.activity">
        <div class="page__row">
          <div class="page__item">
            <AppButton title="Принять"
                       type="fourth"
                       @click.native="decisionApprove(true)"
            />
          </div>
          <div class="page__item">
            <AppButton title="Отказать"
                       type="second"
                       @click.native="decisionApprove(false)"
            />
          </div>
        </div>
      </transition>
      <transition name="fade" v-if="vote.voted">
        <p class="mb-20">Вы утвердили документ. Чтобы изменить решение, обратитесь к создателю листа.</p>
      </transition>

      <AppTabsSlider :space-between="20"
                     :tabs="[
        { name: 'Основное', routeName: 'ApproveUpdate_main', disabled: false },
        { name: 'Контроль', routeName: 'ApproveUpdate_controls', disabled: false },
        { name: 'Ответственные', routeName: 'ApproveUpdate_responsibles', disabled: false }
      ]"
      />
    </section>

    <router-view/>

    <section class="section page__footer">
      <div v-if="!isDisabling" class="page__buttons">
        <div class="page__item">
          <AppButton
            :title="isCreate ? 'Создать' : 'Сохранить'"
            type="main"
            @click.stop.native="saveOrderInfo"
          />
        </div>
        <div class="page__item">
          <AppButton
            title="Отмена"
            type="alt"
            @click.stop.native="cancelEditApprove"
          />
        </div>
      </div>
    </section>

    <ThePagePreloader v-if="isCreate ? false : isLoading"/>
  </main>
</template>

<script>
import AppButton from '@/components/page/button/AppButton'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import AppTabsSlider from '@/components/page/tabs/AppTabsSlider'
import AppButtonSmEdit from '@/components/page/button/AppButtonSmEdit'
import AppButtonSmExport from '@/components/page/button/AppButtonSmExport'
import { mapMutations } from 'vuex'

export default {
  name: 'ApproveUpdate',

  components: {
    AppButtonSmExport,
    AppButtonSmEdit,
    AppTabsSlider,
    AppButton,
    ThePagePreloader
  },

  data () {
    return {
      isCreate: false
    }
  },

  computed: {
    isLoading () {
      return this.$store.getters['approve/details/[approve] getItemUpdateIsLoading']
    },
    isDisabling () {
      return this.$store.getters['approve/details/[approve] getItemUpdateIsDisabling']
    },
    vote () {
      return this.$store.getters['approve/details/[approve] getItemUpdateCanVote']
    },
    canEdit () {
      return this.$store.getters['approve/details/[approve] getItemUpdateCanEdit']
    },
    approve () {
      return this.$store.getters['approve/details/[approve] getItemForUpdate']
    },
    currentUserData () {
      return this.$store.getters.currentUserData
    }
  },

  mounted () {
    if (!this.currentUserData.id || this.currentUserData.full_name === 'Вход не выполнен') {
      this.$router.push('/approve/list/new')
    }
    this.initPage()
  },

  destroyed () {
    this.RESET_FILES_TO_DELETE()
  },

  methods: {
    ...mapMutations('approve/details', {
      RESET_FILES_TO_DELETE: 'RESET_FILES_TO_DELETE'
    }),

    initPage () {
      const id = this.$router.history.current.params.id
      this.$store.commit('approve/details/[approve] SET_INITIAL_STATE')

      if (id === 'create') {
        this.isCreate = true
        this.$store.dispatch('approve/details/[approve] getTreaties')
        this.$store.dispatch('approve/details/[approve] getUsersOptions')
        // Добавление текущего пользователя контролирующим лицом
        this.$store.commit('approve/details/[approve] SAVE_ITEM_UPDATE_CONTROL', { id: this.currentUserData.id, name: this.currentUserData.full_name })
      } else {
        this.$store.dispatch('approve/details/[approve] getApproveItem', id)
        this.$store.dispatch('approve/details/[approve] getTreaties')
        this.$store.dispatch('approve/details/[approve] getUsersOptions')
      }
    },
    saveOrderInfo () {
      const id = this.$router.history.current.params.id
      this.$store.dispatch('approve/details/saveApproveItem', id)
    },
    leavePage () {
      this.$router.push({ name: 'ApproveList' })
      this.$store.commit('approve/details/[approve] SET_INITIAL_STATE')
    },
    doEditApprove () {
      this.$store.commit('approve/details/[approve] ENABLE_ITEM_UPDATE_EDITING')
    },
    cancelEditApprove () {
      if (this.$route.params.id === 'create') this.leavePage()
      else this.initPage()
    },
    getReport (value) {
      this.$store.dispatch('approve/details/[approve] getItemUpdateReport', value)
    },
    decisionApprove (value) {
      this.$store.dispatch('approve/details/[approve] decisionItemUpdate', value)
    }
  }
}
</script>
